<template>
	<div class="language-switch" @click="toggleLanguage">
		<img src="@/assets/home/language.svg" alt="language" class="language-icon" :style="{ width: '25px', height: '18px' }" />
	</div>
</template>

<script>
	export default {
		name: "LanguageSwitch",
		data() {
			return {
				languages: ["zh", "en"],
				currentIndex: 0,
			};
		},
		mounted() {
			// 初始化当前语言索引
			const currentLocale = localStorage.getItem("language") || "en";
			this.currentIndex = this.languages.indexOf(currentLocale);
			if (this.currentIndex === -1) {
				this.currentIndex = 0;
			}
		},
		methods: {
			toggleLanguage() {
				// 切换到下一个语言
				this.currentIndex = (this.currentIndex + 1) % this.languages.length;
				const newLocale = this.languages[this.currentIndex];

				// 设置新语言
				this.$i18n.locale = newLocale;

				// 保存到本地存储
				localStorage.setItem("language", newLocale);

				// 触发语言切换事件，通知其他组件
				this.$emit("language-changed", newLocale);

				// 可选：显示切换提示
				this.$toast(this.getLanguageName(newLocale));
			},
			getLanguageName(locale) {
				const languageNames = {
					zh: "简体中文",
					en: "English",
				};
				return languageNames[locale] || locale;
			},
		},
	};
</script>

<style scoped>
	.language-switch {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		padding: 4px;
		border-radius: 4px;
		transition: background-color 0.2s ease;
	}

	.language-switch:hover {
		background-color: rgba(0, 0, 0, 0.05);
	}

	.language-icon {
		display: block;
		object-fit: contain;
	}
</style>
